/*
 * @Descripttion:
 * @Author: voanit
 * @Date: 2020-11-02 19:47:16
 * @LastEditors: zhangxu
 * @LastEditTime: 2025-09-08 17:22:21
 */
import ajax from '@/utils/ajax'
import { request } from '@/utils/request'
import { option } from 'runjs'

export function courseList(options) {
  return ajax({
    url: '/sgsf-platform/courses/page',
    method: 'POST',
    option: options
  })
}
export function courseListRequest(data) {
  return request({
    url: '/sgsf-platform/courses/page',
    method: 'POST',
    data
  })
}
export function changeCourseStatus(options) {
  return ajax({
    url: `/sgsf-platform/courses/${options.data.courseId}/set-status`,
    method: 'put',
    option: options
  })
}
export function addCourse(options) {
  return ajax({
    url: '/sgsf-platform/courses',
    method: 'POST',
    option: options
  })
}
//创建与编辑课程
export function editRecordCourse(data) {
  return request({
    // url: `/sgsf-platform/courses/${data.courseId}`,
    url: `/sgsf-platform/courses-admin`,
    method: 'post',
    data
  })
}
//保存课程下整体课次基本信息
export function editCourseChapterAll(data) {
  return request({
    url: `/sgsf-platform/courses-admin/${data.courseId}/chapters`,
    method: 'put',
    data
  })
}
//创建单课次基本信息
export function editCourseChapter(data) {
  return request({
    url: `/sgsf-platform/courses-admin/${data.courseId}/chapter`,
    method: 'put',
    data,
    nomessage: true
  })
}
//课次上传随堂测
export function exercisesUpload(upload) {
  let data = upload.data
  return request({
    url: `/sgsf-platform/courses-admin/${upload.courseId}/chapter/${upload.chapterId}/exercises`,
    method: 'put',
    data
  })
}
//课次上传练习
export function homeworkUpload(upload) {
  let data = upload.data
  return request({
    url: `/sgsf-platform/courses-admin/${upload.courseId}/chapter/${upload.chapterId}/homework`,
    method: 'put',
    data
  })
}

//课次上传资料
export function materialsUpload(upload) {
  let data = upload.data
  return request({
    url: `/sgsf-platform/courses-admin/${upload.courseId}/chapter/${upload.chapterId}/materials`,
    method: 'put',
    data
  })
}
//上传讲义
export function noteMaterialsSave(upload) {
  let data = upload.data
  return request({
    url: `sgsf-platform/courses-admin/${upload.courseId}/chapter/${upload.chapterId}/notes-materials`,
    method: 'put',
    data
  })
}
//删除课次
export function deleteCourseChapter(data) {
  return request({
    url: `/sgsf-platform/courses-admin/${data.courseId}/chapter/${data.chapterId}`,
    method: 'delete',
    data
  })
}
export function recordCourseDetail(options) {
  return ajax({
    url: `/sgsf-platform/courses/${options.data.courseId}/detail`,
    method: 'get',
    option: options
  })
}
export function teacherList(options) {
  return ajax({
    url: '/sgsf-platform/teachers',
    method: 'get',
    option: options
  })
}
export function getUnlockNum(options) {
  return ajax({
    url: '/sgsf-platform/chapters/unlock/numbers',
    method: 'get',
    option: options
  })
}
export function getCheckTopic(options) {
  return ajax({
    url: '/sgsf-platform/courses/exercises-answer/count',
    method: 'get',
    option: options
  })
}
export function getCheckHomeWork(options) {
  return ajax({
    url: `/sgsf-platform/courses/${options.data.chapterId}/explain-homework/${options.data.id}`,
    method: 'get',
    option: options
  })
}
// 获取模块
export function getCourseModules(options) {
  return ajax({
    url: '/sgsf-platform/course-modules',
    method: 'get',
    option: options
  })
}

// 5.8. 获取模块下对应的课程数
export function getCourseModulesNum(options) {
  return ajax({
    url: `/sgsf-platform/courses/module-course/${options.data.moduleId}`,
    method: 'get',
    option: options
  })
}
export function getSpecialCourseNum(options) {
  return ajax({
    url: `/sgsf-platform/courses/special-course/count`,
    method: 'get',
    option: options
  })
}

//获取教材及模块
export function getCourseMaterialModules(params) {
  return request({
    url: '/sgsf-platform/course-modules/teaching-material',
    method: 'get',
    params
  })
}
export function moduleEdit(options) {
  return ajax({
    url: `sgsf-platform/courses/${options.data.courseId}/sort/${options.data.courseModuleSort}`,
    method: 'PUT',
    option: options
  })
}
//课程目录
export function catalogList(params) {
  return request({
    url: '/sgsf-platform/courses/catalogue/data',
    method: 'get',
    params
  })
}
export function catalogListExport(data) {
  return request({
    url: '/sgsf-platform/courses/catalogue/export',
    method: 'post',
    data,
    responseType: 'blob'
  })
}

// 2.13. 获取课程类型知识解读
export function getCourseTypeList(params) {
  return request({
    url: `/sgsf-platform/courses/coursetype/moredetail`,
    method: 'get',
    params
  })
}

// 2.14. 设置课程类型解读
export function setCourseType(data) {
  return request({
    url: `/sgsf-platform/courses/coursetype/moredetail`,
    method: 'put',
    data
  })
}

export function getChapterList(data) {
  return request({
    url: '/sgsf-platform/courses/chapter/page',
    method: 'POST',
    data
  })
}
export function getChapterDetail(params) {
  return request({
    url: '/sgsf-platform/courses/chapter-detail',
    method: 'get',
    params
  })
}
export function getChapterListAll(data) {
  return request({
    url: '/sgsf-platform/courses/chapter/list',
    method: 'POST',
    data,
    nomessage: true
  })
}
export function getChapterQuestion(data) {
  return request({
    url: '/sgsf-platform/chapters/chapter-question/page',
    method: 'POST',
    data
  })
}

export function setCourseStatus(data) {
  return request({
    url: `/sgsf-platform/courses-admin/${data.courseId}/set-status`,
    method: 'put',
    data
  })
}
//批量上下架
export function setAllStatus(data) {
  let status = data.status
  data = data.courseIds
  return request({
    url: `/sgsf-platform/courses-admin/batch-set-status/${status}`,
    method: 'put',
    data
  })
}

export function setChapterStatus(data) {
  return request({
    url: `/sgsf-platform/courses-admin/${data.chapterId}/chapter-set-status`,
    method: 'put',
    data,
    nomessage: true
  })
}
export function getChapterReviserDetail(params) {
  return request({
    url: '/sgsf-platform/courses/chapter-reviser',
    method: 'get',
    params
  })
}

export function chapterReviser(data) {
  return request({
    url: `sgsf-platform/courses-admin/${data.chapterId}/reviser?confirm=${data.confirm}`,
    method: 'put',
    data
  })
}
export function checkCourseStatus(params) {
  return request({
    url: `sgsf-platform/courses/status-check`,
    method: 'get',
    params
  })
}
//获取课程知识点
export function getKnowledgeData(params) {
  return request({
    url: `sgsf-platform/chapter-knowledge-point/chapter/${params.chapterId}`,
    method: 'get',
    params
  })
}
//课程知识点绑定
export function seveKnowledgeData(data) {
  return request({
    url: `sgsf-platform/chapter-knowledge-point/save`,
    method: 'post',
    data
  })
}

export function seveKnowledgeDataTemp(data) {
  return request({
    url: `sgsf-platform/chapter-knowledge-point/save/temp`,
    method: 'post',
    data
  })
}
//查询未完成绑定知识点的课程信息
export function chapterKnowledgeUnbind(data) {
  return request({
    url: `sgsf-platform/chapter-knowledge-point/unbind/chapter`,
    method: 'post',
    data
  })
}
//停止配置课程知识点
export function chapterKnowledgeStop(data) {
  return request({
    url: `sgsf-platform/chapter-knowledge-point/stop-binding`,
    method: 'post',
    data
  })
}

// 问题反馈列表
export function problemList(data) {
  return request({
    url: `sgsf-feedback/problem-feedback/page`,
    method: 'post',
    data
  })
}

//重复问题列表
export function repeatProblemList(data) {
  return request({
    url: `sgsf-feedback/problem-feedback/chapter-quote/page`,
    method: 'post',
    data
  })
}
//问题反馈详情
export function getProblemDetail(params) {
  return request({
    url: `sgsf-feedback/problem-feedback/feedback-detail`,
    method: 'get',
    params
  })
}

//问题反馈提交
export function commitFeedBack(data) {
  return request({
    url: `sgsf-feedback/problem-feedback/reply`,
    method: 'post',
    data
  })
}

//问题反馈列表导出
export function problemListExport(data) {
  return request({
    url: 'sgsf-feedback/problem-feedback/export',
    method: 'post',
    data,
    responseType: 'blob'
  })
}

//问题字典
export function getProblemTypeList(params) {
  return request({
    url: `sgsf-feedback/problem-feedback/problem-dict`,
    method: 'get',
    params
  })
}

//课次开放区域绑定
export function saveRegion(data) {
  return request({
    url: `/sgsf-platform/chapter-regions/${data.chapterId}/save`,
    method: 'post',
    data: data.regionCodes
  })
}

//定时上下架
export function setExpectRemovalDate(data) {
  return request({
    url: `/sgsf-platform/courses-admin/${data.courseId}/set-expect-removal-date`,
    method: 'PUT',
    data
  })
}
//复制课程
export function copyRecordCourse(data) {
  return request({
    url: `/sgsf-platform/courses-admin/copy-course/${data.courseId}`,
    method: 'post',
    data: data
  })
}
//批量复制课程
export function batchCopyRecordCourse(data) {
  return request({
    url: `/sgsf-platform/courses-admin/batch-copy-course`,
    method: 'post',
    data: data
  })
}

//背诵资料列表
export function getMaterialPage(data) {
  return request({
    url: `/sgsf-platform/recite/material/page`,
    method: 'post',
    data: data
  })
}
//教材列表
export function getbookPage(data) {
  return request({
    url: `/sgsf-platform/recite/book/page`,
    method: 'post',
    data: data
  })
}

//新增背诵资料
export function addMaterial(data) {
  return request({
    url: `/sgsf-platform/recite/save/material`,
    method: 'post',
    data: data
  })
}
// 新建背记资料/修改
export function saveRecitePpoin(data) {
  return request({
    url: `/sgsf-platform/recite/point/save`,
    method: 'post',
    data
  })
}

// 获取 干扰答案

export function getQuestionDistract(data) {
  return request({
    url: `/sgsf-ai/question/answer/distract`,
    method: 'post',
    data
  })
}

// 记背资料资料详情
export function getRecitePpoinDetail(params) {
  return request({
    url: `/sgsf-platform/recite/point/detail/${params.id}`,
    method: 'get',
    params
  })
}
// 批量获取记背资料资料详情
export function getReciteMoreDetail(params) {
  return request({
    url: `/sgsf-platform/recite/point/batch-detail`,
    method: 'get',
    params
  })
}

//获取背诵资料详情
export function getmaterialDetail(params) {
  return request({
    url: `/sgsf-platform/recite/material/${params.id}`,
    method: 'get',
    params
  })
}

//背诵资料审校
export function materialreviser(data) {
  return request({
    url: `/sgsf-platform/recite/material/reviser`,
    method: 'post',
    data
  })
}

export function getRecitePpoinReviser(data) {
  return request({
    url: `/sgsf-platform/recite/point/reviser`,
    method: 'post',
    data
  })
}

export function getRecitePpoinList(data) {
  return request({
    url: `/sgsf-platform/recite/point/page`,
    method: 'POST',
    data
  })
}

//添加教材

export function saveReciteBook(data) {
  return request({
    url: `/sgsf-platform/recite/book/save`,
    method: 'post',
    data
  })
}

//获取教材详情

export function getReciteBook(params) {
  return request({
    url: `/sgsf-platform/recite/${params.bookId}/detail`,
    method: 'get',
    params
  })
}

// 20.5. 课次配置背记资料
export function setChapterRecite(data) {
  return request({
    url: `/sgsf-platform/recite/point/chapter/save`,
    method: 'post',
    data
  })
}

export function getChapterRecite(params) {
  return request({
    url: `/sgsf-platform/recite/point/chapter/recite/${params.chapterId}`,
    method: 'get',
    params
  })
}
//教材上下架
export function setReciteBookStatis(data) {
  return request({
    url: `/sgsf-platform/recite/${data.bookId}/set-status/${data.status}`,
    method: 'PUT',
    data
  })
}
export function downloadsInit(params) {
  return request({
    url: '/sgsf-download-center/downloads/init',
    method: 'get',
    params
  })
}

// 课程目录获取联动数据 - 年级、难度、老师
export function getCascadeTypeData(params) {
  return request({
    url: '/sgsf-platform/courses/catalogue/type',
    method: 'get',
    params
  })
}
export function chapterUnbind(data) {
  return request({
    url: `sgsf-platform/chapters/unbind/${data.chapterId}`,
    method: 'post',
    data
  })
}
export function chapterBind(data) {
  return request({
    url: 'sgsf-platform/chapters/bind',
    method: 'post',
    data
  })
}
